import { Observable, of } from 'rxjs';
import { Injectable, ViewContainerRef } from '@angular/core';
import { Rtl2SsoService } from '@rtl2/sso';
import { Rtl2UiInterface, Rtl2UiMenu } from '@rtl2/ui';
import { SharedEnvironmentService } from '@shared/services';

@Injectable()
export class SharedUiInterfaceService implements Rtl2UiInterface {
  menu: Observable<Rtl2UiMenu>;

  constructor(private ssoService: Rtl2SsoService, private environment: SharedEnvironmentService) {
    const roles = this.environment.get('authRoles');
    this.menu = new Observable(function (observer) {
      observer.next({
        environments: {
          test: {
            app: 't-propo.rtl2cloud.de',
          },
          integration: {
            app: 'i-propo.rtl2cloud.de',
          },
          production: {
            app: 'p-propo.rtl2cloud.de',
          },
        },
        permissions: {
          disabled: { test: {}, integration: {}, production: {} },
          roles: {
            app: [...roles],
          },
        },
        metadata: {
          app: {
            id: 'app',
            name: 'routeTitle.producersPortal',
            tags: [],
            description: '',
          },
        },
      });
    });
  }

  menuGetMenuName(name: string): Observable<string> {
    return of('');
  }

  menuGetMenuNameCurrent(): Observable<string> {
    return of('routeTitle.producersPortal');
  }

  ssoCheckRole(roles: string[]): boolean {
    return this.ssoService.checkRole(roles);
  }

  ssoCheckRoleObserve(roles: string[]): Observable<boolean> {
    return this.ssoService.checkRoleObserve(roles);
  }

  notificationAddComponentSnackBar(viewContainerRef: ViewContainerRef): void {
    return null;
  }

  notificationAddComponentDialog(viewContainerRef: ViewContainerRef): void {
    return null;
  }

  fetchMenu() {}

  environmentVar(name: string): any {
    return this.environment.get(name);
  }
}
